import { useEffect } from "react";

function setMeta(name, content, attr = "name") {
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

export const siteOrigin = () => window.__VL_ORIGIN || "https://www.vlover.nl";
export const breadcrumbItems = (items) => items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: siteOrigin() + path }));

export default function Seo({ title, description, canonical, jsonld, noindex }) {
  useEffect(() => {
    document.title = title ? `${title} | VLOVER by Next Level` : "VLOVER by Next Level – PVC vloer & laminaat kopen";
    setMeta("description", description || "PVC vloer en laminaat kopen bij VLOVER by Next Level uit Wormerveer: prijs per m² en per pak, eerlijke levertijd.");
    setMeta("og:title", document.title, "property");
    setMeta("og:description", description || "PVC vloer en laminaat kopen bij VLOVER by Next Level.", "property");
    setMeta("og:type", "website", "property");
    setMeta("og:url", siteOrigin() + (canonical || window.location.pathname), "property");
    window.__VL_PAGE_NOINDEX = !!noindex;
    setMeta("robots", noindex || window.__VL_NOINDEX !== false ? "noindex, nofollow" : "index, follow");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = siteOrigin() + (canonical || window.location.pathname);
    let s = document.getElementById("vl-jsonld");
    if (s) s.remove();
    if (jsonld) {
      s = document.createElement("script"); s.type = "application/ld+json"; s.id = "vl-jsonld";
      s.text = JSON.stringify(jsonld); document.head.appendChild(s);
    }
  }, [title, description, canonical, jsonld, noindex]);
  return null;
}
